import PropTypes from 'prop-types'
import React, {useEffect, useState} from 'react'
import {getMonth} from 'ag-common/facades'
import i18n from 'i18next'
import actions from 'redux-auto'
import DialogControlButtons from '#components/m/Versetzungsplan/DialogControlButtons'
import {endOfMonth, startOfMonth, getUnixTime} from 'ag-common/facades'
import {RessourcenAbteilungSelect} from './RessourcenAbteilungSelect'
import MonthRangePicker from '../MonthPicker/MonthRangePicker'
import InputNumber from '#components/a/form/InputNumber'
import api from '#services/api'

function RessourcenDialog({onClose, abteilungen, abteilungenLoading}) {
  const [selectedAbteilungId, setSelectedAbteilungId] = useState()
  const [isUpdating, setIsUpdating] = useState(false)
  const [startDate, setStartDate] = useState(startOfMonth(new Date()))
  const [endDate, setEndDate] = useState(endOfMonth(new Date()))
  const [azubiCount, setAzubiCount] = useState('')

  useEffect(() => {
    if (abteilungen?.length > 0) {
      setSelectedAbteilungId(abteilungen[0].id)
    }
  }, [abteilungen])

  const selectAbteilung = abteilungId => {
    setSelectedAbteilungId(abteilungId)
  }

  const changeAzubiCount = e => {
    const newValue = parseInt(e.target.value, 10)
    if (isNaN(newValue)) {
      setAzubiCount('')
    } else {
      setAzubiCount(newValue)
    }
  }

  const handleSubmit = async event => {
    event.preventDefault()
    const ressourcenCreationModel = {
      abteilungsId: selectedAbteilungId,
      startMonth: getMonth(startDate) + 1,
      endMonth: getMonth(endDate) + 1,
      azubiCount,
    }
    try {
      setIsUpdating(true)
      const ressourcen = await api.createOrUpdateRessourcenplanung(ressourcenCreationModel)
      actions.ressourcen.updateRessourcePlan(ressourcen)
    } catch (e) {
      actions.error.writeError({error: e})
    } finally {
      setIsUpdating(false)
      onClose()
    }
  }

  const closeDialog = evt => {
    evt.stopPropagation()
    onClose()
  }

  return (
    <form onSubmit={handleSubmit} className="ressourcenDialog" data-testid="ressourcenplanung-form">
      <RessourcenAbteilungSelect
        abteilungen={abteilungen}
        selectedAbteilungId={selectedAbteilungId}
        selectAbteilung={selectAbteilung}
        abteilungenLoading={abteilungenLoading}
      />
      <MonthRangePicker
        startDate={startDate}
        endDate={endDate}
        setStartDate={setStartDate}
        setEndDate={setEndDate}
        isMonthOnly
      />
      <div className="azubiCountInput" data-testid="azubi-count-input">
        <InputNumber
          value={azubiCount}
          placeholder={i18n.t('ressourcenplanung_azubi_count_placeholder')}
          labelText={i18n.t('ressourcenplanung_azubi_count_label')}
          onChangeHandle={changeAzubiCount}
          modifier="dark"
        />
      </div>
      <DialogControlButtons
        onCloseClick={closeDialog}
        disableSubmit={azubiCount === ''}
        disabledSubmitReason={i18n.t('ressourcenplanung_disabled_button_text')}
        isLoading={isUpdating}
      />
    </form>
  )
}

RessourcenDialog.propTypes = {
  onClose: PropTypes.func,
  abteilungen: PropTypes.array,
  abteilungenLoading: PropTypes.bool,
}

export default RessourcenDialog
